import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Artist API
export const fetchArtist = async () => {
  try {
    const response = await axios.get(`${API}/artist`);
    return response.data;
  } catch (error) {
    console.error('Error fetching artist:', error);
    throw error;
  }
};

// Music API
export const fetchMusic = async () => {
  try {
    const response = await axios.get(`${API}/music`);
    return response.data;
  } catch (error) {
    console.error('Error fetching music:', error);
    throw error;
  }
};

// Writing API
export const fetchWriting = async () => {
  try {
    const response = await axios.get(`${API}/writing`);
    return response.data;
  } catch (error) {
    console.error('Error fetching writing:', error);
    throw error;
  }
};

// Events API
export const fetchEvents = async () => {
  try {
    const response = await axios.get(`${API}/events`);
    return response.data;
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};

// Testimonials API
export const fetchTestimonials = async () => {
  try {
    const response = await axios.get(`${API}/testimonials`);
    return response.data;
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    throw error;
  }
};

// Contact API
export const submitContact = async (formData) => {
  try {
    const response = await axios.post(`${API}/contact`, formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

// Newsletter API
export const subscribeNewsletter = async (email) => {
  try {
    const response = await axios.post(`${API}/newsletter`, { email });
    return response.data;
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    throw error;
  }
};
